import { StartEditingCellParams } from "ag-grid-community";
import { DealerDetails } from "../dealer/DealerDetails";

export class NewQuote {
portfolioId: number;
portfolioName: string;
status: number;
dealerId: string;
dealerName: string;
modelDesc: string;
modelDescHN: string;
modelActiveFlag: number;
newQuotFlag: number;
variantDesc: string;
variantDescHN: string;
variantActiveFlag: number;
exShowroomPrice: number;

newVehBrandId: string = "";
newVehBrandName: string;
newVehBrandNameHN: string;

newVehModelId: string;
newVehModelName: string;
newVehModelNameHN: string;

newVehVariantId: string;
newVehVarName: string;
newVehVarNameHN: string;

isNewCar ?: boolean = true;

//usedVehBank: string;
usedVehBrandId:string;

userId: string = "";

quotationId = "";
custId="";

statusId ="";

dlrState: string;
dlrCity: string;
dlrPinCode: string;
dealer : string;

dealerDetail: DealerDetails;


constructor() {
    this.dealerDetail=new DealerDetails();
}
} 
